import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NotificationTemplateDTO, NotificationTemplateGenSvc } from 'src/app/services_autogenerated/generated_services';

@Component({
    selector: 'app-notification-template-maintenance',
    templateUrl: './notification-template-maintenance.component.html',
    styleUrls: ['./notification-template-maintenance.component.css'],
    standalone: false
})
export class NotificationTemplateMaintenanceComponent implements OnInit {
  public isLoading: boolean = true;
  public templateForm: UntypedFormGroup;

  constructor(
      private notificationTemplateService: NotificationTemplateGenSvc,
      private route: ActivatedRoute,
      private formBuilder: UntypedFormBuilder,
      private messageService: MessageService,
      private router: Router
    ) {
      this.templateForm = this.formBuilder.group({
        name: [undefined, Validators.required],
        subject: [undefined, Validators.required],
        title: [undefined, Validators.required],
        body: [undefined, Validators.required],
        extra: [undefined]
      })
    }

  ngOnInit() {
    const id = +this.route.snapshot.paramMap.get('id');

    this.notificationTemplateService.getById(id)
      .pipe(catchError((error) => {
        this.isLoading = false;

        return of(null);
      }))
      .subscribe(res => {
        this.templateForm.get('name').setValue(res.name);
        this.templateForm.get('subject').setValue(res.subject);
        this.templateForm.get('title').setValue(res.title);
        this.templateForm.get('body').setValue(res.body);
        this.templateForm.get('extra').setValue(res.extra);
        this.isLoading = false;
      });
  }

  save() {
    const id = +this.route.snapshot.paramMap.get('id');
    const updateDTO = new NotificationTemplateDTO();

    updateDTO.id = id;
    updateDTO.name =  this.templateForm.get('name').value;
    updateDTO.title =  this.templateForm.get('title').value;
    updateDTO.subject =  this.templateForm.get('subject').value;
    updateDTO.body =  this.templateForm.get('body').value;
    updateDTO.extra =  this.templateForm.get('extra').value;
    updateDTO.active = true;

    this.notificationTemplateService.update(updateDTO)
    .pipe(catchError((error) => {
      this.isLoading = false;
      
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: 'An error has occurred, please retry and contact support if it persists.',
      sticky: false
    });

      return of(null);
    }))
    .subscribe(res => {
      this.router.navigateByUrl('/notificationTemplates');
    });
  }

}
